import { ChartCard, DonutChart, type DonutDatum } from '~/components/charts'

// 역할 분포 도넛 — user · admin · superadmin 권한 구성.
export function RoleDistributionCard({
    roleDist,
    total,
    empty,
}: {
    roleDist: DonutDatum[]
    total: number
    empty: boolean
}) {
    return (
        <div className='mb-4'>
            <ChartCard
                title='역할 분포'
                description='user · admin · superadmin 권한 구성'
                empty={empty}
                emptyText='사용자가 없어요.'>
                <DonutChart
                    data={roleDist}
                    centerValue={total}
                    centerLabel='전체 사용자'
                />
            </ChartCard>
        </div>
    )
}
